import React from 'react';
import Datepicker from '@bexs/dollar/components/Datepicker';
import { DatepickerProps } from '@bexs/dollar/components/Datepicker/types';
import IconCalendar from '@bexs/dollar-icons/Calendar';
import { DatepickerWithIconWrap } from 'components/Datepicker/styles';

/**
 * Temporary solution until @bexs/dollar provide
 * a complete Datepicker rendering, including icon.
 */
function DatepickerWithIcon(props: DatepickerProps) {
  return (
    <DatepickerWithIconWrap>
      <Datepicker
        {...props}
        isMultiple
        numberOfVisibleMonths={2}
        position="bottom-right"
        maxDate={new Date()}
      />
      <IconCalendar size="20px" />
    </DatepickerWithIconWrap>
  );
}

export default DatepickerWithIcon;
